import PropTypes from 'prop-types'
import { isNil } from 'ramda'
import ActiveRecord from 'model/activeRecord'
import dayjs from 'dayjs'

class NewImplementationType extends ActiveRecord {
  constructor(init) {
    super(init)
    if (isNil(init)) return undefined

    this._accumulator_contact_email = init.accumulator_contact_email
    this._accumulator_contact_name = init.accumulator_contact_name
    this._accumulator_contact_phone = init.accumulator_contact_phone
    this._accumulator_layout_type = init.accumulator_layout_type
    this._accumulator_processing_method = init.accumulator_processing_method
    this._accumulator_reconciliation_file = init.accumulator_reconciliation_file
    this._accumulator_response_file = init.accumulator_response_file
    this._accumulator_vendor_name = init.accumulator_vendor_name
    this._claim_contact_email = init.claim_contact_email
    this._claim_contact_name = init.claim_contact_name
    this._claim_contact_phone = init.claim_contact_phone
    this._claim_layout_type = init.claim_layout_type
    this._claim_vendor_name = init.claim_vendor_name
    this._client_name = init.client_name
    this._created_at = init.created_at
    this._eligibility_contact_email = init.eligibility_contact_email
    this._eligibility_contact_name = init.eligibility_contact_name
    this._eligibility_contact_phone = init.eligibility_contact_phone
    this._eligibility_layout_type = init.eligibility_layout_type
    this._eligibility_production_file_date =
      init.eligibility_production_file_date
    this._eligibility_vendor_name = init.eligibility_vendor_name
    this._employee_id = init.employee_id
    this._expected_go_live_date = init.expected_go_live_date
    this._id = init.id
    this._id_card_type = init.id_card_type
    this._implementation_manager = init.implementation_manager
    this._jira_ticket_links = init.jira_ticket_links
    this._sftp = init.sftp
    this._source_attachments = init.source_attachments
    this._updated_at = init.updated_at
  }

  static shape = {
    accumulator_contact_email: PropTypes.string,
    accumulator_contact_name: PropTypes.string,
    accumulator_contact_phone: PropTypes.string,
    accumulator_layout_type: PropTypes.string,
    accumulator_processing_method: PropTypes.string,
    accumulator_reconciliation_file: PropTypes.bool,
    accumulator_response_file: PropTypes.bool,
    accumulator_vendor_name: PropTypes.string,
    claim_contact_email: PropTypes.string,
    claim_contact_name: PropTypes.string,
    claim_contact_phone: PropTypes.string,
    claim_layout_type: PropTypes.string,
    claim_vendor_name: PropTypes.string,
    client_name: PropTypes.string,
    created_at: PropTypes.string,
    eligibility_contact_email: PropTypes.string,
    eligibility_contact_name: PropTypes.string,
    eligibility_contact_phone: PropTypes.string,
    eligibility_layout_type: PropTypes.string,
    eligibility_production_file_date: PropTypes.string,
    eligibility_vendor_name: PropTypes.string,
    employee_id: PropTypes.number,
    expected_go_live_date: PropTypes.string,
    id: PropTypes.string,
    id_card_type: PropTypes.string,
    implementation_manager: PropTypes.string,
    jira_ticket_links: PropTypes.arrayOf(PropTypes.string),
    sftp: PropTypes.string,
    source_attachments: PropTypes.arrayOf(PropTypes.string),
    updated_at: PropTypes.number
  }

  get accumulator_contact_email() {
    return this._accumulator_contact_email
  }

  get accumulator_contact_name() {
    return this._accumulator_contact_name
  }

  get accumulator_contact_phone() {
    return this._accumulator_contact_phone
  }

  get accumulator_layout_type() {
    return this._accumulator_layout_type
  }

  get accumulator_processing_method() {
    return this._accumulator_processing_method
  }

  get accumulator_reconciliation_file() {
    return this._accumulator_reconciliation_file
  }

  get accumulator_response_file() {
    return this._accumulator_response_file
  }

  get accumulator_vendor_name() {
    return this._accumulator_vendor_name
  }

  get claim_contact_email() {
    return this._claim_contact_email
  }

  get claim_contact_name() {
    return this._claim_contact_name
  }

  get claim_contact_phone() {
    return this._claim_contact_phone
  }

  get claim_layout_type() {
    return this._claim_layout_type
  }

  get claim_vendor_name() {
    return this._claim_vendor_name
  }

  get client_name() {
    return this._client_name
  }

  get created_at() {
    return this._created_at
  }

  get eligibility_contact_email() {
    return this._eligibility_contact_email
  }

  get eligibility_contact_name() {
    return this._eligibility_contact_name
  }

  get eligibility_contact_phone() {
    return this._eligibility_contact_phone
  }

  get eligibility_layout_type() {
    return this._eligibility_layout_type
  }

  get eligibility_production_file_date() {
    return dayjs(new Date(this._eligibility_production_file_date).toISOString())
  }

  get eligibility_vendor_name() {
    return this._eligibility_vendor_name
  }

  get employee_id() {
    return this._employee_id
  }

  get expected_go_live_date() {
    return dayjs(new Date(this._expected_go_live_date).toISOString())
  }

  get id() {
    return this._id
  }

  get id_card_type() {
    return this._id_card_type
  }

  get implementation_manager() {
    return this._implementation_manager
  }

  get jira_ticket_links() {
    return this._jira_ticket_links
  }

  get sftp() {
    return this._sftp
  }

  get source_attachments() {
    return this._source_attachments
  }

  get updated_at() {
    return this._updated_at
  }
}

export default NewImplementationType
